import { ProgressMeter } from "@msuite/ui/progress-meter";
import { motion } from "motion/react";
import { DROPZONE_SPRING } from "./dropzone-spring";

/** Props Interface */
interface GeneralDropzoneProgressProps {
	/** How far the transfer has got, as a percentage. */
	value: number;
}

/**
 * The transfer's own row, shown for as long as an upload runs. It collapses its height rather
 * than leaving the pill's flex flow, for the same reason the drop target does: a row pulled out
 * of the column takes the pill's width with it and the exit stops being continuous.
 *
 * The meter carries no label. The line above it already names how many files are in flight, and
 * a percentage beside the bar answers a question the bar has already answered.
 */
export function GeneralDropzoneProgress({ value }: GeneralDropzoneProgressProps) {
	/** Render */
	return (
		<motion.div
			initial={{ height: 0, opacity: 0 }}
			animate={{ height: "auto", opacity: 1 }}
			exit={{ height: 0, opacity: 0 }}
			transition={DROPZONE_SPRING}
			className="overflow-hidden"
		>
			<div className="px-1 pt-3">
				<ProgressMeter
					value={value}
					hideLabel
				/>
			</div>
		</motion.div>
	);
}
